
import { Vue } from "vue-class-component";
import {getSwitchingTimesLogsRequest} from "@/services/ObjectService";
import moment from "moment";

export default class SwitchingTimes extends Vue {
	headline = "Schaltzeiten Logs"
	logs: any = []
	moment = moment
	
	
	getLogs() {
		getSwitchingTimesLogsRequest().then((res: any) => {
			if ( res.status == "OK" && res.result.length > 0 ) {
				this.logs = res.result
			}
		})
	}
	
	beforeMount() {
		this.getLogs()
	}
}
